import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "../../core";

export const HeaderEdit = ({ content: oldContent, handleClose, handleSave }) => {

  const {value = {}} = oldContent

  const [content, setContent] = useState(value);
  const { title } = content;

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setContent({
      ...content,
      [name]: value,
    });
  };

  return (
    <Dialog open={true} fullWidth>
      <DialogTitle>Edição da Header</DialogTitle>
      <DialogContent>
        <TextField
          label="Título"
          value={title}
          onChange={handleChange}
          fullWidth
          name="title"
        />
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => {
            handleSave(content);
            handleClose();
          }}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
